import BaseOptionsBundle from "%/dynamic-component-editor/classes/base-options";
import Positioning from "%/dynamic-component-editor/options/positioning";

export default class PositioningOptions extends BaseOptionsBundle {

  optionTitle = "Positioning";
  static optionClassName = "i-dynamic-position";

  constructor(values = {}, hideFromInspector = {}) {
    super(values, [
      new Positioning(undefined, hideFromInspector["positioning"] ?? false),
    ]);
  }
}
